import {
  LIST_PROFILE_CONFIGURATION_REQUEST,
  LIST_PROFILE_CONFIGURATION_SUCCESS,
  LIST_PROFILE_CONFIGURATION_FAIL,
  LIST_USER_INTERNAL_PROFILE_CONFIGURATION_REQUEST,
  LIST_USER_INTERNAL_PROFILE_CONFIGURATION_SUCCESS,
  LIST_USER_INTERNAL_PROFILE_CONFIGURATION_FAIL,
  SET_PROFILE_CONFIGURATION_ACTIVE_REQUEST,
  SET_PROFILE_CONFIGURATION_ACTIVE_SUCCESS,
  SET_PROFILE_CONFIGURATION_ACTIVE_FAIL,
  CREATE_PROFILE_CONFIGURATION_REQUEST,
  CREATE_PROFILE_CONFIGURATION_SUCCESS,
  CREATE_PROFILE_CONFIGURATION_FAIL,
  DETAIL_PROFILE_CONFIGURATION_REQUEST,
  DETAIL_PROFILE_CONFIGURATION_SUCCESS,
  DETAIL_PROFILE_CONFIGURATION_FAIL,
  UPDATE_PROFILE_CONFIGURATION_REQUEST,
  UPDATE_PROFILE_CONFIGURATION_SUCCESS,
  UPDATE_PROFILE_CONFIGURATION_FAIL,
  DELETE_PROFILE_CONFIGURATION_REQUEST,
  DELETE_PROFILE_CONFIGURATION_SUCCESS,
  DELETE_PROFILE_CONFIGURATION_FAIL
} from '../../constants/profile-configuration'

const initialState = {
  loading: false,
  profileConfigurations: [],
  userInternalProfileConfigurations: [],
  loadingDelete: false,
  loadingCreate: false,
  profileConfiguration: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listProfileConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PROFILE_CONFIGURATION_REQUEST:
      return { ...state, loading: true }
    case LIST_PROFILE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        profileConfigurations: action.payload,
        pageable: action.pageable
      }
    case LIST_PROFILE_CONFIGURATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        profileConfigurations: []
      }
    case LIST_USER_INTERNAL_PROFILE_CONFIGURATION_REQUEST:
      return { ...state, loading: true }
    case LIST_USER_INTERNAL_PROFILE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        pageable: action.pageable,
        userInternalProfileConfigurations: action.payload
      }
    case LIST_USER_INTERNAL_PROFILE_CONFIGURATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        userInternalProfileConfigurations: action.dummy
      }
    case LIST_USER_INTERNAL_PROFILE_CONFIGURATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        userInternalProfileConfigurations: action.dummy
      }
    case SET_PROFILE_CONFIGURATION_ACTIVE_REQUEST:
      return { ...state, loadingActive: true }
    case SET_PROFILE_CONFIGURATION_ACTIVE_SUCCESS:
      return { ...state, loadingActive: false }
    case SET_PROFILE_CONFIGURATION_ACTIVE_FAIL:
      return { ...state, loadingActive: false, error: action.payload }
    case CREATE_PROFILE_CONFIGURATION_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_PROFILE_CONFIGURATION_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_PROFILE_CONFIGURATION_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_PROFILE_CONFIGURATION_REQUEST:
      return { ...state, loadingCreate: true, profileConfiguration: {} }
    case DETAIL_PROFILE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        profileConfiguration: action.payload
      }
    case DETAIL_PROFILE_CONFIGURATION_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload,
        profileConfiguration: {}
      }
    case UPDATE_PROFILE_CONFIGURATION_REQUEST:
      return { ...state, loadingCreate: true }
    case UPDATE_PROFILE_CONFIGURATION_SUCCESS:
      return { ...state, loadingCreate: false }
    case UPDATE_PROFILE_CONFIGURATION_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_PROFILE_CONFIGURATION_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PROFILE_CONFIGURATION_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_PROFILE_CONFIGURATION_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    default:
      return state
  }
}

export default listProfileConfigurationReducer
